import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "flexShrink", "align", "minInlineSize"];
import { Flex } from '../../../components/Flex';

/**
 * CHANGE:
 * - `size` prop removed as it is not used outside of UIComponents.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const MediaLeft = _ref => {
  let {
      children,
      flexShrink,
      align,
      minInlineSize
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Flex, Object.assign({}, rest, {
    flexShrink: flexShrink,
    order: 1,
    minInlineSize: minInlineSize,
    alignItems: align,
    children: children
  }));
};
MediaLeft.displayName = 'MediaLeft';